import { CampaignCase } from './types';

type CaseSeed = Partial<CampaignCase> & Pick<CampaignCase, 'number' | 'report' | 'subject' | 'status' | 'opened'>;

function buildCase(seed: CaseSeed): CampaignCase {
  return {
    lastModified: '',
    email: '',
    recordType: 'Luxury Escapes Partner Services',
    owner: '',
    originalOwner: '',
    contactAccount: '',
    shortDetail: '',
    zendeskId: '',
    opportunity: '',
    priority: 'Medium',
    origin: 'Email',
    checkIn: '',
    reason: '',
    isOpen: true,
    emails: [],
    history: [],
    attachments: [],
    feed: [],
    ...seed,
  };
}

// Static fixtures with made-up people, companies and ids, until the case API exists.
export const MOCK_CASES: ReadonlyArray<CampaignCase> = [
  buildCase({
    number: '10000001',
    report: 'all',
    subject: 'RE: Card overcharge - 100000001 - Example Payments',
    status: 'New',
    opened: '25/09/2026 7:04 PM',
    lastModified: '28/09/2026 8:48 AM',
    email: 'pat.example@example.com',
    owner: 'Sam Taylor',
    originalOwner: 'Morgan Blake',
    shortDetail: 'Hi team, the 20 affected bookings match the records on our end as well. Please find…',
    opportunity: 'Example Resort Ultra Lux',
    emails: [
      {
        subject: 'RE: Card overcharge - 100000001 - Example Payments',
        from: 'pat.example@example.com',
        to: 'alex.sample@example.com; finance.team@example.com',
        date: '25/09/2026 7:03 PM',
      },
    ],
    history: [
      { date: '28/09/2026 8:48 AM', field: 'Case Owner', user: 'Morgan Blake', original: '', next: 'Sam Taylor' },
      { date: '25/09/2026 7:03 PM', field: 'Created', user: 'System', original: '', next: '' },
    ],
    attachments: [
      { name: 'screenshot-1.png', date: '25/09/2026' },
      { name: 'screenshot-2.png', date: '25/09/2026' },
      { name: 'screenshot-3.png', date: '25/09/2026' },
      { name: 'screenshot-4.png', date: '25/09/2026' },
      { name: 'screenshot-5.png', date: '25/09/2026' },
      { name: 'screenshot-6.png', date: '25/09/2026' },
    ],
    feed: [
      {
        id: 'f1',
        type: 'update',
        author: 'Morgan Blake',
        createdAt: '2026-09-28T08:48:00',
        text: '',
        updatedField: 'Case Owner',
        updatedValue: 'Sam Taylor',
        comments: [],
      },
      {
        id: 'f2',
        type: 'update',
        author: 'System',
        createdAt: '2026-09-25T19:04:00',
        text: '',
        updatedField: 'Customers Email',
        updatedValue: 'pat.example@example.com',
        comments: [],
      },
      {
        id: 'f3',
        type: 'email',
        author: 'Pat Example',
        audience: 'The LuxGroup Only',
        createdAt: '2026-09-25T19:03:00',
        text: 'The 20 affected bookings match the records on our end as well. Please find the attached screenshots.',
        emailTo: ['alex.sample@example.com', 'finance.team@example.com'],
        comments: [],
      },
      { id: 'f4', type: 'created', author: 'System', createdAt: '2026-09-25T19:03:00', text: '', comments: [] },
    ],
  }),
  buildCase({
    number: '10000002',
    report: 'all',
    subject: 'Re: IMPORTANT - Your Campaign Launch - Sample Wine Tours',
    status: 'Closed - Resolved (Partner)',
    opened: '13/08/2026 2:20 PM',
    email: 'bookings@example.org',
    recordType: 'Experience Cases',
    owner: 'Experiences Queue',
    shortDetail: 'Thank you, kind regards, Jamie Demo, Operations Manager, Sample Wine Tours…',
    isOpen: false,
  }),
  buildCase({
    number: '10000003',
    report: 'all',
    subject: 'Re: Card overcharge - 100000001 - Example Payments',
    status: 'New',
    opened: '24/09/2026 3:36 PM',
    email: 'finance.team@example.com',
    owner: 'Taylor Quinn',
    contactAccount: 'Finance Team',
    shortDetail: 'Hi there, there are 20 such bookings which we identified. Please find the attachment for your…',
  }),
  buildCase({
    number: '10000004',
    report: 'all',
    subject: 'RB - Sample Island Resort - AB1234 / CD5678 / EF9012 - manager email referring to all cases',
    status: 'Closed - Resolved (Partner)',
    opened: '17/04/2026 10:49 AM',
    email: 'dana.sample@example.com',
    owner: 'Jamie Cole',
    contactAccount: 'Dana Sample',
    shortDetail: 'Thanks, yes if you could chat with the resort that would be great. Might be worth winding up…',
    zendeskId: '1000001',
    isOpen: false,
  }),
  buildCase({
    number: '10000005',
    report: 'all',
    subject: 'Stop sell Demo Island Escapes & Example Vacation Club - Partner Portal Information',
    status: 'Closed - Resolved (Partner)',
    opened: '19/03/2026 3:48 PM',
    email: 'avery.stone@example.com',
    owner: 'Riley Fox',
    contactAccount: 'Avery Stone',
    shortDetail: 'Thank you for your email, I am out of office until the next business day.',
    zendeskId: '1000002',
    priority: 'High',
    isOpen: false,
  }),
  buildCase({
    number: '10000006',
    report: 'all',
    subject: 'RE: [Fwd] Fwd: Tour Campaign Link - Demo Tours Co - 70 Highlights, 11D Foodie & 14D Best of Tours',
    status: 'Closed - Resolved (Partner)',
    opened: '4/01/2026 10:54 AM',
    email: 'rod.sample@example.com',
    recordType: 'Tour',
    owner: 'Tours Queue',
    contactAccount: 'Rod Sample',
    shortDetail: 'Yes all good to close, it’s just that they changed the original excursion for this program…',
    isOpen: false,
  }),
  buildCase({
    number: 'COC-AS-01',
    report: 'owner',
    owner: 'Avery Stone',
    subject: '00000000-0000-4000-8000-000000000001 - 2026-09-21 - Booking Request',
    status: 'Pending Partner Response',
    opened: '21/09/2026 11:20 AM',
    lastModified: '23/09/2026',
    priority: 'High',
  }),
  buildCase({
    number: 'COC-AS-04',
    report: 'owner',
    owner: 'Avery Stone',
    subject: '700000001 - 24/09/2026 - Contract Dispute (Pre-Checkin)',
    status: 'Pending Internal Review',
    opened: '23/09/2026 9:35 AM',
    lastModified: '24/09/2026',
    checkIn: '13/10/2026',
    priority: 'High',
  }),
  buildCase({
    number: 'COC-JR-01',
    report: 'owner',
    owner: 'Jordan Reed',
    subject: 'Sample Hotel Nadi - VAT Query',
    status: 'Pending',
    opened: '22/04/2026 4:54 PM',
    lastModified: '4/05/2026',
    reason: 'Connectivity Review',
    priority: 'High',
  }),
  buildCase({
    number: 'COC-CL-02',
    report: 'owner',
    owner: 'Casey Lin',
    subject: 'LE-ABC123 - 23/09/2026 - Booking Request',
    status: 'Pending Partner Response',
    opened: '23/09/2026 12:38 PM',
    lastModified: '24/09/2026',
    checkIn: '10/03/2027',
    priority: 'High',
  }),
  buildCase({
    number: 'COC-RP-01',
    report: 'owner',
    owner: 'Riley Park',
    subject: '800000001 - 29/08/2026 - Website Error',
    status: 'New',
    opened: '29/08/2026 8:27 PM',
    lastModified: '31/08/2026',
    checkIn: '21/08/2026',
    priority: 'High',
  }),
  buildCase({
    number: 'COC-RP-02',
    report: 'owner',
    owner: 'Riley Park',
    subject: '800000002 - 10/07/2026 - Vendor Contact - CANCELLATION REQUEST',
    status: 'New',
    opened: '10/07/2026 3:41 PM',
    lastModified: '31/07/2026',
    checkIn: '28/06/2026',
    priority: 'High',
  }),
];

export function findMockCase(caseNumber: string | undefined): CampaignCase | undefined {
  return MOCK_CASES.find((caseItem) => caseItem.number === caseNumber);
}
